/**
 * Manage theme data
 */
import Ajax from '@/lib/ajax_wrapper'

const THEME_PATH = '/admin/themes'

/**
 * Read paginated themes
 *
 * @returns {promise}
 */
export function readThemesData() {
  return Ajax.request({
    url: THEME_PATH
  })
}

/**
 * Create a theme
 *
 * @param {object} theme
 * @param {string} theme.name
 *
 * @returns {promise}
 */
export function createThemeData(theme) {
  return Ajax.request({
    url: THEME_PATH,
    method: 'POST',
    data: {theme}
  })
}

/**
 * Read a theme
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function readThemeData(id) {
  return Ajax.request({
    url: `${THEME_PATH}/${id}`
  })
}

/**
 * Update a theme
 *
 * @param {string} id
 * @param {object} theme
 * @param {string} theme.name
 *
 * @returns {promise}
 */
export function updateThemeData(id, theme) {
  return Ajax.request({
    url: `${THEME_PATH}/${id}`,
    method: 'PATCH',
    data: {theme}
  })
}

/**
 * Delete a theme
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function deleteThemeData(id) {
  return Ajax.request({
    url: `${THEME_PATH}/${id}`,
    method: 'DELETE'
  })
}
